<template>
  <success :show-promotes='false'>
    <thanks :email='email' :title="$t('billing.success.ppm.extension_purchased')">
      <subtitle grey-background :sub-title="$t('billing.success.ppm.extension_desc')" />
      <subtitle grey-background :sub-title="$t('billing.success.ppm.download_desc', { version: extensionConfig.ppmClientVersion, downloadUrl: extensionConfig.downloadCenter})" />
      <template v-if='isEligible4HomeDestination'>
        <zm-button data-testid="checkout-button-104" type='primary' @click='goToHDPage'> {{ $t('billing.success.get_started') }}</zm-button>
      </template>
      <view-account v-else />
    </thanks>
  </success>
</template>
<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template/index.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import common from '@/views/succezz/mixin/common';
import { mapGetters } from 'vuex';
import { getBasicConfig$Cache } from '@/common/service/common';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import { navigateToTargetPage } from '@/utils/modal-utils';

export default {
  name: 'PPM',
  mixins: [common],
  components: { ViewAccount, Success, Subtitle, Thanks },
  data() {
    return {
      extensionConfig: {
        ppmClientVersion: "5.15.10",
        downloadCenter: "https://zoom.us/download#client_4meeting"
      },
    }
  },
  computed: {
    ...mapGetters(['successConfig']),
    isEligible4HomeDestination() {
      return this.$config('isEligible4HomeDestination');
    },
  },
  async created() {
    await this.getExtentionConfig();
  },
  methods: {
    async getExtentionConfig() {
      try {
        const { result } = await getBasicConfig$Cache();
        result.downloadCenter && (this.extensionConfig.downloadCenter = result.downloadCenter);
        result.ppmClientVersion && (this.extensionConfig.ppmClientVersion = result.ppmClientVersion);
      } catch (e) {
        console.log(e);
      }
    },
    goToHDPage() {
      this.$tracking.buyInteraction('purchase confirmation', 'explore my plan');
      navigateToTargetPage(`${window.location.origin}/myhome`);
    },
  },
}
</script>
